/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg id="b778d73e-0856-4d08-813f-07b826ec5cb9" width="66" height="66" viewBox="0 0 66 66" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <g id="e0ffd49a-c8e6-42d8-9354-15eff80d6961">
          <g id="a15f1bbc-fe09-4605-8f5b-c0708b38a27d">
            <g id="ee5e6942-9f88-4cb9-b786-a61bd4250e5a">
              <g id="e1cf7525-4e63-4ad9-a0e0-edc18d1d6d74">
                <g id="f1aeef10-18f2-4989-a464-b33914928f0f">
                  <path id="b3ba476c-7cee-4e40-a380-b00bd378ba64" d="M40.5,33.87l-12,6.82a1,1,0,0,1-1.33-.37.94.94,0,0,1-.13-.48V26.2a1,1,0,0,1,1-1,1,1,0,0,1,.48.12l12,6.82a1,1,0,0,1,.37,1.34A1.09,1.09,0,0,1,40.5,33.87Z" transform="translate(0 -0.52)" fill="#fff" className="icon-fill" fillRule="evenodd"/>
                  <circle id="edcf232c-944e-49c0-9015-a47f60df3d61" cx="33" cy="33" r="32" stroke="#fff" style={{ fill: 'none' }} className="icon-stroke" strokeWidth="2px"/>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'PlayMediaIcon';

export default Icon;
